import React from "react";
import AppTemplate from "../components/Conditions";

const Conditions: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default Conditions;
